import React from "react";
import {
    Box,
    Grid,
    Typography,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
} from "@mui/material";
import Strings from "../../utils/stringUtil";
import AppIcons from "../../utils/appIcons";
import { isMobile } from "../../utils/responsiveUtil";
import styles from "../../assets/styles/main.module.css";
import theme from "../../utils/themeUtil";
import TextSize from "../../utils/textSizeUtil";
import { Link } from "react-router-dom";
import FillButton from "../ui/fillButton";
import Routes from "../../utils/routesUtil";

const FeatureItem = ({ title, description, iconSrc }) => (
    <ListItem
        sx={{
            "&:hover": {
                backgroundColor: "transparent",
            },
        }}
    >
        <ListItemIcon>
            <Box mr={1.5}>
                <img
                    src={iconSrc}
                    alt="Icon"
                    height={isMobile ? "34px" : "55px"}
                />
            </Box>
        </ListItemIcon>
        <ListItemText
            primary={
                <Box mb={0.5}>
                    <Typography
                        color="textSecondary"
                        style={{
                            fontSize: TextSize.size16,
                            fontWeight: "500",
                            color: theme.palette.black.main,
                        }}
                    >
                        {title}
                    </Typography>
                </Box>
            }
            secondary={
                <Typography
                    style={{
                        fontSize: TextSize.size14,
                        color: theme.palette.grey.main,
                    }}
                >
                    {description}
                </Typography>
            }
        />
    </ListItem>
);

function LoanMerit() {
    const features = [
        {
            title: Strings.businessLoans5Lakhs,
            description: Strings.startScaleYourBusiness,
            iconSrc: AppIcons.imgFeatureIconCircle,
        },
        {
            title: Strings.simpleOnlineProcess,
            description: Strings.submitDocumentRepayments,
            iconSrc: AppIcons.imgFeatureIconCircle,
        },
        {
            title: Strings.noCollateralNoGuarantor,
            description: Strings.loanCollateralFree,
            iconSrc: AppIcons.imgFeatureIconCircle,
        },
    ];

    return (
        <React.Fragment>
            <Box bgcolor={theme.palette.lightWhite.main} pt={isMobile ? 2 : 5} pb={5}>
                <Box className={styles.container}>
                    <Box
                        bgcolor={theme.palette.white.main}
                        boxShadow={3}
                        borderRadius={4}
                        textAlign="center"
                        p={isMobile ? 2 : 5}
                    >
                        <Grid container>
                            <Grid item xs={12} md={3} style={{ textAlign: "left" }}>
                                <img
                                    src={AppIcons.imgCongratulationsPhone}
                                    height="512px"
                                    width="100%"
                                    alt="Congratulations Phone"
                                />
                            </Grid>
                            <Grid item xs={12} md={9} style={{ textAlign: "left" }}>
                                <Box mt={4}>
                                    <Box pl={2}>
                                        <Typography
                                            fontSize={isMobile ? TextSize.size20 : TextSize.size24}
                                            style={{ fontWeight: "600" }}
                                        >
                                            {Strings.loanMerit}
                                        </Typography>
                                    </Box>
                                    <List>
                                        {features.map((feature, index) => (
                                            <FeatureItem
                                                key={index}
                                                title={feature.title}
                                                description={feature.description}
                                                iconSrc={feature.iconSrc}
                                            />
                                        ))}
                                    </List>
                                    <Box pl={2}>
                                        <Link to={Routes.MAHILA_LOAN}>
                                            <FillButton
                                                backgroundColor={theme.palette.primary.main}
                                                textColor={theme.palette.white.main}
                                                text={Strings.applyNow}
                                            />
                                        </Link>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Box>
        </React.Fragment>
    );
}

export default LoanMerit;
